import React from 'react';

function JftUser() {
  return <div>JftUser</div>;
}

export default JftUser;
